import { render, staticRenderFns } from "./RequestsWriteDownPoints.vue?vue&type=template&id=3a0fe01f&scoped=true"
import script from "./RequestsWriteDownPoints.vue?vue&type=script&lang=js"
export * from "./RequestsWriteDownPoints.vue?vue&type=script&lang=js"
import style0 from "./RequestsWriteDownPoints.vue?vue&type=style&index=0&id=3a0fe01f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fe01f",
  null
  
)

export default component.exports